import React from 'react';
import { HelpCircleIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { authorQuestions, images } from '../../data/landing';
export function Author() {
  return <section className="bg-navy-950 py-16 text-white sm:py-24" aria-labelledby="author-title" data-id="element-58" data-mp="1wh6xikffhds8">
      <div className="mx-auto max-w-5xl px-5" data-id="element-59" data-mp="1rq8cj7jhvrin">
        <div className="grid gap-10 lg:grid-cols-[380px_1fr] lg:items-start" data-id="element-60" data-mp="1rodvw5f9alkd">
          <div className="lg:sticky lg:top-8" data-id="element-61" data-mp="25gbxlv6n1f6i">
            <img src={images.author} alt="Dr. Ryan Carter, physical therapist" className="aspect-[4/5] w-full rounded-3xl object-cover ring-1 ring-white/10" data-id="element-62" data-mp="25j6gvjdx0tyc" />
            <p className="mt-4 text-center text-sm font-bold uppercase tracking-wider text-brand-400" data-id="element-63" data-mp="2agpt6dr1ywnn">
              Creator of the Hernia Clinical Playbook™
            </p>
          </div>

          <div data-id="element-64" data-mp="g2f4c5agk2hv">
            <h2 id="author-title" className="font-display text-[2.2rem] font-black leading-tight sm:text-5xl" data-id="element-65" data-mp="g2oy83ymitsu">
              Meet Dr. Ryan Carter
            </h2>
            <p className="mt-5 border-l-4 border-brand-500 pl-4 font-display text-xl font-bold italic leading-snug text-white sm:text-2xl" data-id="element-66" data-mp="3gc9q8d1u9bnd">
              “I created this Playbook because I know what it’s like to have the knowledge… but not have a clear
              structure for applying it.”
            </p>
            <p className="mt-6 text-lg leading-relaxed text-white/80" data-id="element-67" data-mp="3u7lx1it9qskn">
              Over the years, I’ve seen many physical therapists study anatomy, physiology, assessment, rehabilitation,
              and different treatment approaches. But when a more complex patient walks into the clinic, another
              question often appears:
            </p>
            <ul className="mt-5 grid gap-2.5 sm:grid-cols-2" data-id="element-68" data-mp="gxxz676t1e7o">
              {authorQuestions.map(q => <li key={q} className="flex items-center gap-2.5 rounded-xl bg-white/[0.06] px-4 py-3 text-base font-semibold" data-id="element-69" data-mp="2dt2gcugiekky">
                  <HelpCircleIcon className="h-5 w-5 shrink-0 text-brand-400" aria-hidden="true" data-id="element-70" data-mp="2isfbe2hjaxym" />
                  {q}
                </li>)}
            </ul>
            <p className="mt-6 text-lg leading-relaxed text-white/80" data-id="element-71" data-mp="3h3zud1dpj0ke">
              The problem isn’t always a lack of information. Sometimes, the missing piece is a system for organizing
              that information.
            </p>
            <p className="mt-4 text-lg leading-relaxed text-white/80" data-id="element-72" data-mp="8uzuivdw33b5">
              I didn’t want to create another textbook filled with theory. I wanted to create a practical tool that you
              could open before a session, use while organizing your clinical plan, and return to after seeing your
              patient — a system organized into 6 professional volumes, supported by checklists, algorithms, clinical
              cases, communication tools, and practical resources.
            </p>
            <p className="mt-6 rounded-2xl bg-white p-5 text-lg font-bold leading-relaxed text-navy-900" data-id="element-73" data-mp="mmmtj2z7upxm">
              My goal is simple: help you turn your clinical knowledge into a more organized and repeatable process.
            </p>
            <p className="mt-5 font-display text-2xl font-bold italic text-brand-400" data-id="element-74" data-mp="1b5ybjmybni2v">— Dr. Ryan Carter</p>
          </div>
        </div>

        <CtaButton className="mt-12" tone="dark" label="I want to turn my knowledge into a system" data-id="element-75" data-mp="wccwkfmc0k2n" />
      </div>
    </section>;
}